/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardCupIcon16Light = forwardRef('AwardCupIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 2a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v1.6a3.5 3.5 0 0 1-3.012 3.466A4.25 4.25 0 0 1 8 10.993V14h2.5a.5.5 0 1 1 0 1h-6a.5.5 0 0 1 0-1H7v-3.007a4.25 4.25 0 0 1-3.988-3.927A3.5 3.5 0 0 1 0 3.6V2Zm12 4.05a2.5 2.5 0 0 0 2-2.45V2h-2v4.05ZM11 2H4v4.75A3.25 3.25 0 0 0 7.25 10h.5A3.25 3.25 0 0 0 11 6.75V2ZM1 2h2v4.05A2.5 2.5 0 0 1 1 3.6V2Z" })));
});
